import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/native';
import useMobile from '../hooks/use-mobile';
import useMedia from '../hooks/use-media';
import Colors from '../colors';
import Icon from '../icon';
import Spacer from '../spacer';
import Text from '../text';
const StyledBg = styled.View`
  background-color: ${Colors.indigo400};
  width: 100%;
  align-items: center;
`;
const StyledContainer = styled.View`
  width: 720px;
`;
const Row = styled.View`
  flex-direction: row;
`;
const StyledIconTile = styled.View`
  width: 49px;
  height: 49px;
  background-color: ${Colors.lightGray200};
  border-radius: 4px;
  justify-content: center;
  align-items: center;
  margin-top: 9px;
`;
const StyledDetails = styled.View`
  flex-grow: 1;
`;
const StyledInfo = styled.View`
  justify-content: space-between;
`;
export default function AdvanceDetailsHeader(props) {
  const mobile = useMobile();
  const tablet = useMedia();
  const smallTablet = useMedia(720);
  const spacer = mobile ? 'f24' : 'd40';
  const iconSize = mobile ? 25 : 30.63;
  const StyledIcon = props.iconFamily;
  return /*#__PURE__*/React.createElement(StyledBg, null, /*#__PURE__*/React.createElement(StyledContainer, {
    style: [(mobile || smallTablet) && styles.mobileWidth, tablet && styles.tablet]
  }, /*#__PURE__*/React.createElement(Spacer, {
    size: "f24",
    height: true
  }), !props.simple && /*#__PURE__*/React.createElement(React.Fragment, null, props.header, /*#__PURE__*/React.createElement(Spacer, {
    size: spacer,
    height: true
  })), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(StyledIconTile, {
    style: mobile && styles.mobileIcon
  }, /*#__PURE__*/React.createElement(StyledIcon, {
    name: props.iconName,
    color: Colors.advanceBlue400,
    size: iconSize
  })), /*#__PURE__*/React.createElement(Spacer, {
    size: "d16",
    width: true
  }), /*#__PURE__*/React.createElement(StyledDetails, null, /*#__PURE__*/React.createElement(Text.H3, {
    color: Colors.lightGray200
  }, props.children), /*#__PURE__*/React.createElement(Spacer, {
    size: "f4",
    height: true
  }), /*#__PURE__*/React.createElement(StyledInfo, {
    style: mobile ? styles.column : styles.row
  }, /*#__PURE__*/React.createElement(Text.BodyExtraSmall, {
    color: Colors.indigo100
  }, "Reference No.", ' ', props.referenceNumber), /*#__PURE__*/React.createElement(Spacer, {
    size: "f8",
    height: true
  }), /*#__PURE__*/React.createElement(Text.BodyExtraSmall, {
    color: Colors.indigo100
  }, props.disbursementDate)))), /*#__PURE__*/React.createElement(Spacer, {
    size: "f24",
    height: true
  })));
}
AdvanceDetailsHeader.defaultProps = {
  header: null,
  children: '',
  disbursementDate: '',
  referenceNumber: '',
  simple: false,
  iconName: '',
  iconFamily: Icon.MaterialIcons
};
AdvanceDetailsHeader.propTypes = {
  header: PropTypes.object,
  children: PropTypes.string,
  disbursementDate: PropTypes.string,
  referenceNumber: PropTypes.string,
  simple: PropTypes.bool,
  iconName: PropTypes.string,
  iconFamily: PropTypes.elementType
};
const styles = {
  mobileWidth: {
    width: '100%',
    paddingLeft: 16
  },
  mobileIcon: {
    marginTop: 4,
    width: 40,
    height: 40
  },
  row: {
    flexDirection: 'row'
  },
  column: {
    flexDirection: 'column'
  },
  tablet: {
    paddingHorizontal: 16
  }
};
//# sourceMappingURL=index.js.map